<script>
  import Icon from "fa-svelte";
  import { faBars } from "@fortawesome/free-solid-svg-icons/faBars";
  import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
  import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons/faSignOutAlt";
  import { faSignInAlt } from "@fortawesome/free-solid-svg-icons/faSignInAlt";
  import { faAsterisk } from "@fortawesome/free-solid-svg-icons/faAsterisk";
  import { faLeaf } from "@fortawesome/free-solid-svg-icons/faLeaf";
  import { faWalking } from "@fortawesome/free-solid-svg-icons/faWalking";
  import { faGlobe } from "@fortawesome/free-solid-svg-icons/faGlobe";
  import { link, replace, location } from "svelte-spa-router";
  import { languages, user, reset, userLoggedIn } from "../services/store";
  import LanguageSelect from "./LanguageSelect.svelte";
  import { LOGO_PATH } from "../model/Config";
  import {
    navigateToLetters,
    navigateToNature,
    navigateToCulture,
    navigateToWorld,
  } from "../helper/Router";
  import { _ } from "svelte-i18n";

  let allLanguages;
  let navbarOpen = false;
  let selectedIcon = faBars;
  let selected;

  function onLogout() {
    reset();
    replace("/login");
  }
  $: if ($location.indexOf("/letters/") > -1) {
    selected = "letters";
  } else if ($location.indexOf("/nature/") > -1) {
    selected = "nature";
  } else if ($location.indexOf("/culture/") > -1) {
    selected = "culture";
  } else if ($location.indexOf("/world/") > -1) {
    selected = "world";
  } else {
    selected = null;
  }

  function setNavbarOpen() {
    navbarOpen = !navbarOpen;
    selectedIcon = navbarOpen ? faTimes : faBars;
  }
  const unsubscribe = languages.subscribe((value) => {
    if (value) {
      allLanguages = value;
    }
  });
</script>

<style>
  .selected {
    background-color: #e9c46a;
    border: 1px solid white;
  }
</style>

<nav
  class="w-full top-0 relative flex flex-wrap items-center justify-between px-2 py-1 navbar-expand-lg ">
  <div
    class="container px-4 mx-auto flex flex-wrap items-center justify-between">
    <div
      class=" w-full relative flex justify-between lg:w-auto  lg:static lg:justify-start">
      <div>
        <a
          class="text-sm font-bold leading-relaxed inline-block whitespace-no-wrap uppercase text-white"
          href="/">
          <img
            class="w-12 float-left"
            src="https://biliplus.de/assets/img/logo.png"
            alt="BiliPlus Logo" />
          <span class="relative hidden sm:inline-block" style="top:13px">
            {$_('navbar.mainTitle')}
          </span>
        </a>
      </div>
      {#if $user && $user.link && $user.logo}
        <div class="flex flex-row px-2">
          <!-- <a
            class="text-sm self-center font-bold leading-relaxed hidden sm:inline-block   whitespace-no-wrap uppercase text-white"
            href={$user.link}>
            {$user.fullName}</a> -->
          <img class="max-h-12" src="{LOGO_PATH}{$user.logo}" alt="User Logo" />
        </div>
      {/if}
      <button
        class="text-white cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
        type="button"
        on:click={setNavbarOpen}>
        <Icon icon={selectedIcon} />
      </button>
    </div>
    <div
      class="lg:flex flex-grow items-center sm:glass lg:bg-transparent lg:shadow-none rounded shadow-lg {navbarOpen ? 'block' : 'hidden'}">
      <ul class="flex flex-col lg:flex-row list-none ml-auto">
        <!-- @TODO activate once more languages are available >2 -->
        {#if $userLoggedIn}
          <li class="nav-item">
            <button
              class:selected={selected === 'letters'}
              on:click={navigateToLetters}
              class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75">
              <Icon icon={faAsterisk} />
              <span class="ml-2">{$_('navbar.letters')}</span>
            </button>
          </li>
          <li class="nav-item">
            <button
              class:selected={selected === 'nature'}
              on:click={navigateToNature}
              class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75">
              <Icon icon={faLeaf} />
              <span class="ml-2">{$_('navbar.nature')}</span>
            </button>
          </li>
          <li class="nav-item">
            <button
              class:selected={selected === 'culture'}
              on:click={navigateToCulture}
              class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75">
              <Icon icon={faWalking} />
              <span class="ml-2">{$_('navbar.culture')}</span>
            </button>
          </li>
          <li class="nav-item">
            <button
              class:selected={selected === 'world'}
              on:click={navigateToWorld}
              class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75">
              <Icon icon={faGlobe} />
              <span class="ml-2">{$_('navbar.world')}</span>
            </button>
          </li>
          {#if allLanguages && allLanguages.length > 2}
            <LanguageSelect />
          {:else if allLanguages}
            <li class="nav-item">
              <span
                class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75">
                {$_(`languages.${allLanguages[0].value}`)}
                {$_('navbar.and')}
                {$_(`languages.${allLanguages[1].value}`)}
              </span>
            </li>
          {/if}
        {/if}
        <li class="nav-item">
          {#if !$userLoggedIn}
            <a
              href="/login"
              use:link
              class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75">
              <Icon icon={faSignInAlt} />
              <span class="ml-2">{$_('navbar.login')}</span>
            </a>
          {:else}
            <button
              on:click={onLogout}
              class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75">
              <Icon icon={faSignOutAlt} />
              <span class="ml-2">{$_('navbar.logout')}</span>
            </button>
          {/if}
        </li>
      </ul>
    </div>
  </div>
</nav>
